import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/declare',
  redirect: 'noredirect',
  name: 'declare',
  component: Layout,
  children: [
    {
      path: 'declare',
      component: () => import('@/views/declare/index.vue'),
      name: 'declare',
      meta: {
        title: '数据申报',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
